import { clsx } from 'clsx';

import { SvgCalendar3 } from '@/components/icons';
import { useBudgetStore } from '@/store/budget';

const COUNTS = [1, 2, 3] as const;

/**
 * The three calendar glyphs at the top-left of the budget page — they set how
 * many months are visible side by side.
 */
export function MonthCountSelector() {
  const monthCount = useBudgetStore(state => state.monthCount);
  const setMonthCount = useBudgetStore(state => state.setMonthCount);

  return (
    <div className="flex items-center gap-1 pl-1" data-testid="month-count">
      {COUNTS.map(count => (
        <button
          key={count}
          type="button"
          title={`显示 ${count} 个月`}
          aria-pressed={monthCount === count}
          onClick={() => setMonthCount(count)}
          className={clsx(
            'rounded-sm p-1 hover:bg-button-bare-background-hover',
            monthCount === count
              ? 'text-page-text-positive'
              : 'text-page-text-light',
          )}
        >
          <SvgCalendar3 width={11 + count * 3} height={14} />
        </button>
      ))}
    </div>
  );
}
